import React, { Component } from "react";
import PropTypes from "prop-types";
import throttle from "lodash/throttle";
import debounce from "lodash/debounce";

class CarouselStateHandler extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.debouncedSnapToImage = debounce(this.snapToImage, 700);
    this.state = {
      index: 0,
    };
  }

  componentDidUpdate(prevProps) {
    // If the number of slides for some reason changes, change to 0 index
    // to avoid bugs.
    const { slidesCount } = this.props;
    if (slidesCount !== prevProps.slidesCount) {
      this.changeIndex(0);
    }
  }

  handleScroll = throttle(
    (e, ref) => {
      const { scrollLeft } = e.target;
      e.target.childNodes.forEach((node, index, array) => {
        // left side of image being visible means we snap to that image.
        if (
          scrollLeft >= node.offsetLeft &&
          scrollLeft < node.offsetLeft + node.offsetWidth / 2 &&
          index !== array.length - 1
        ) {
          this.setState({ index });
        }
        // right side of image being visible means we snap to the next image, unless it's the last image.
        else if (
          scrollLeft >= node.offsetLeft + node.offsetWidth / 2 &&
          scrollLeft < node.offsetLeft + node.offsetWidth &&
          index < array.length - 2
        ) {
          this.setState({ index: index + 1 });
        }
        this.debouncedSnapToImage(ref);
      });
    },
    100,
    { trailing: true }
  );

  changeIndex = (index) => {
    this.setState({ index }, this.snapToImage);
  };

  decrement = () => {
    const { index } = this.state;
    if (index > 0) {
      this.setState(
        (currentState) => ({ index: currentState.index - 1 }),
        this.snapToImage
      );
    }
  };

  increment = () => {
    const { index } = this.state;
    const { slidesCount } = this.props;

    if (index < slidesCount - 1) {
      this.setState(
        (currentState) => ({ index: currentState.index + 1 }),
        this.snapToImage
      );
    }
  };

  snapToImage = () => {
    const { index } = this.state;
    this.ref.current.scroll({
      left: this.ref.current.childNodes[index].offsetLeft,
      behavior: "smooth",
    });
  };

  render() {
    const { index } = this.state;
    const { children } = this.props;

    return children({
      ref: this.ref,
      index,
      decrement: this.decrement,
      increment: this.increment,
      changeIndex: this.changeIndex,
      handleScroll: this.handleScroll,
    });
  }
}

CarouselStateHandler.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  slidesCount: PropTypes.number.isRequired,
};

CarouselStateHandler.defaultProps = {
  children: null,
};

export default CarouselStateHandler;
